export enum UserRole {
  "FarmTreeDeveloper" = "FarmTreeDeveloper",
  "FarmTreeMaster" = "FarmTreeMaster",
  "FarmTreeExpert" = "FarmTreeExpert",
  "ProjectOwner" = "ProjectOwner",
  "ClientEditor" = "ClientEditor",
  "ClientViewer" = "ClientViewer",
}
